module.exports = __webpack_public_path__ + "img/1.87bc61e1.svg";